import magnificPopup from 'magnific-popup';
import Popper from 'popper.js';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';


$(document).ready(function() {

  circlePhases();

  $('.pipeline-section__row__content a[href*="#popup"]').magnificPopup({
    type:'inline',
    midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.,
    alignTop:        true,
    fixedContentPos: true,
    callbacks: {
      open: function() {
        $("body .white-popup").addClass("--complete");
        location.href = location.href.split('#')[0] + "#gal";
      },
      close: function() {
        if (location.hash) history.go(-1);
      }
    }
  });

  $('.white-popup__close-btn').on( "click", function() {
    $.magnificPopup.close();
  });

  $("body").on("click", ".pipeline-section__row", function(){
    var tabID =  $(this).data('tab')
    $("*[data-target-tab=" + tabID + "]" ).toggleClass('hide');
    $(this).toggleClass("active");
    //$(this).find('a[href="#"').attr('href', 'pipeline-popup-' + tabID)

    if ( $("*[data-target-tab=" + tabID + "]" ).find("a[href*='#popup']")) {
      $("*[data-target-tab=" + tabID + "]" ).find("a[href*='#popup']").attr('href', '#pipeline-popup-' + tabID);
    }

    if ( $("*[data-target-tab=" + tabID + "]" ).find("a[href*='#tooltip']")) {

      $("*[data-target-tab=" + tabID + "]" ).find("a[href*='#tooltip']").attr('id','tooltip' + tabID).addClass("hover--link");

      tippy('#' + 'tooltip' + tabID, {
        content: $('.tooltip-content-' + tabID).text(),
        theme: 'light',
      });

    }
  });
});

$(window).on('hashchange',function() {
  if(location.href.indexOf("#gal")<0) {
    $.magnificPopup.close();
  }
});

function circlePhases() {
  $('.circle__wrapper').each(function(){
    $('.circle__wrapper .circle').each(function(){
      var circleData = $(this).attr('data-circle'),
      percentageData = $(this).attr('data-percentage');

      if (circleData <= percentageData) {
        $(this).addClass('white-circle');
      }
    });
  })
}
